<template>
  <div>
    <b-row>
      <b-col cols="8">
        <b-input-group prepend="URL" size="sm">
          <b-input-group-prepend v-if="v2" is-text>
            <input
              type="checkbox"
              aria-label="Checkbox for following text input"
            />
          </b-input-group-prepend>
          <b-input-group-prepend is-text
            ><b>{{ urlPrefix }}</b></b-input-group-prepend
          >
          <b-form-input
            type="text"
            aria-label="Text input with checkbox"
            @keydown.space.prevent
            v-model="pageName"
            placeholder="terms"
            @change="handlePageNameChanged"
          />
        </b-input-group>
      </b-col>
      <b-col cols="4">
        <b-button
          size="sm"
          variant="danger"
          class="float-right"
          style="margin-left: 10px;"
          @click="handleRemovePageClick"
        >
          Remove Page
        </b-button>
      </b-col>
    </b-row>
    <br />
    <br />
    <editor
      id="textarea-default"
      @input="input"
      type="text for your page"
      content-size="lg"
      :clear="clear"
      :content="page.content"
      @resetClear="resetClear"
    />
  </div>
</template>

<script>
import Editor from "@/components/common/editor";
export default {
  name: "PageForm",
  components: {
    Editor
  },
  props: {
    page: {
      type: Object,
      default: () => {
        return { name: "", description: "", content: "" };
      }
    }
  },
  data() {
    return {
      v2: false,
      clear: false,
      pageName: this.page.pageName ? this.page.pageName : ""
    };
  },
  computed: {
    urlPrefix() {
      return `https://cornerqr.com/corner/${this.slug}/pages/`;
    },
    slug() {
      return "the-little-ant-that-did";
    }
  },
  methods: {
    input(val) {
      this.$emit("content-update", this.page, val.content);
    },
    resetClear() {
      this.clear = false;
    },
    handleRemovePageClick() {
      this.$emit("remove-page", this.page);
    },
    handlePageNameChanged(value) {
      this.$emit("page-name-change", this.page, value);
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
